import { Guid } from "guid-typescript";
import React from "react";

import "./ContentPortal.scss";

interface ContentPortalProps {
    content: string
};

interface ContentPortalState {
    ref: React.RefObject<HTMLIFrameElement>
};

class ContentPortal extends React.Component<ContentPortalProps, ContentPortalState> {

    state = {
        ref: React.createRef<HTMLIFrameElement>()
    } as ContentPortalState;

    private deployStyles() {
        let document = this.state.ref.current.contentWindow.document,
        styles = document.createElement('style');

        styles.innerHTML = 'body { font: 500 12pt Sans-Serif; min-height: 500px } .bg { min-height: 500px } td.bg { height: 500px } @media (prefers-color-scheme: dark) { body { color: #f0f0f0 } }';
        document.head.appendChild(styles);
    }
    
    render() {

        return (
        <div className="content-portal-container">
            <iframe
                ref={this.state.ref}
                className="content-portal"
                title={Guid.create().toString()}
                srcDoc={this.props.content}
                onLoad={this.deployStyles.bind(this)}>
            </iframe>
        </div>
        );

    }

}

export default ContentPortal;